import { Component, inject, OnDestroy } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { App } from '@capacitor/app';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { AlertController, Platform } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { RouteLoadingService } from './_shared/remote-navigation/route-loading.service';
import { bindRemoteAlert } from './_shared/remote-navigation/remote-alert';
import { KeepAwake } from '@capacitor-community/keep-awake';
import { Capacitor } from '@capacitor/core';


@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    imports: [
        IonApp,
        IonRouterOutlet,
        RouterModule,
    ]
})


export class AppComponent implements OnDestroy {
  private router = inject(Router)
  private alertController = inject(AlertController)

  private readonly platform = inject(Platform);
  private readonly backSubscription: Subscription;
  private creatingExitAlert = false;
  private exitAlert?: HTMLIonAlertElement;
  private disposeAlert?: () => void;

  constructor() {
    inject(RouteLoadingService);

    this.backSubscription = this.platform.backButton.subscribeWithPriority(-1, async () => {
      if (this.router.url.split(/[?#]/)[0] !== '/home') {
        await this.router.navigate(['/home']);
        return;
      }
      if (this.exitAlert || this.creatingExitAlert) return;
      this.creatingExitAlert = true;
      try {
        const previousFocus = document.activeElement as HTMLElement | null;
        const alert = await this.alertController.create({
          header: 'Do you want to exit?',
          cssClass: 'remote-confirmation-alert',
          htmlAttributes: { 'data-testid': 'exit-app-alert' },
          buttons: [{ text: 'Stay', role: 'cancel' }, { text: 'Exit', handler: async () => {
            if (Capacitor.isNativePlatform()) await App.exitApp();
          } }],
        });
        this.exitAlert = alert;
        void alert.onDidDismiss().then(() => {
          this.disposeAlert?.();
          this.disposeAlert = undefined;
          this.exitAlert = undefined;
          if (previousFocus?.isConnected) {
            const native = previousFocus.shadowRoot?.querySelector<HTMLElement>('button, a') ?? previousFocus;
            native.focus();
          }
        });
        await alert.present();
        this.disposeAlert = bindRemoteAlert(alert, 'exit-app');
      } finally { this.creatingExitAlert = false; }
    });
  }

  ngOnDestroy(): void {
    this.backSubscription.unsubscribe();
    this.disposeAlert?.();
  }

  async ngOnInit() {
    if (Capacitor.isNativePlatform()) {
      await KeepAwake.keepAwake();
    }
  }

  
}
